var map = {
	"./assets/images/0/loghi/logo-block.png": 9703,
	"./assets/images/0/loghi/logo-inline.png": 7339,
	"./assets/images/1/loghi/logo-block.png": 4702,
	"./assets/images/1/loghi/logo-inline.png": 5556,
	"./assets/images/10/loghi/logo-block.png": 6649,
	"./assets/images/10/loghi/logo-inline.png": 276,
	"./assets/images/11/loghi/logo-block.png": 4230,
	"./assets/images/11/loghi/logo-inline.png": 272,
	"./assets/images/12/loghi/logo-block.png": 238,
	"./assets/images/12/loghi/logo-inline.png": 3542,
	"./assets/images/2/loghi/logo-block.png": 5587,
	"./assets/images/2/loghi/logo-inline.png": 2953,
	"./assets/images/3/loghi/logo-block.png": 2294,
	"./assets/images/3/loghi/logo-inline.png": 3678,
	"./assets/images/4/loghi/logo-block.png": 2514,
	"./assets/images/4/loghi/logo-inline.png": 5444,
	"./assets/images/5/loghi/logo-block.png": 9635,
	"./assets/images/5/loghi/logo-inline.png": 8110,
	"./assets/images/6/loghi/logo-block.png": 1694,
	"./assets/images/6/loghi/logo-inline.png": 2950,
	"./assets/images/7/loghi/logo-block.png": 8406,
	"./assets/images/7/loghi/logo-inline.png": 486,
	"./assets/images/8/loghi/logo-block.png": 9234,
	"./assets/images/8/loghi/logo-inline.png": 3233,
	"./assets/images/9/loghi/logo-block.png": 9273,
	"./assets/images/9/loghi/logo-inline.png": 2851,
	"./assets/images/badge-app-store.png": 8241,
	"./assets/images/badge-play-store.png": 7967,
	"./assets/images/general/burger-icon.png": 8331,
	"./assets/images/logo-block.png": 5463,
	"./components/header/assets/images/it_flag.png": 2165
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5810;